import { createSvgComponent } from "../../icon/createSvgComponent";
import Clock from "@core/__generated__/icon/figma/clock.svg";
export default createSvgComponent(Clock);